import datepicker from 'js-datepicker'; // https://www.npmjs.com/package/js-datepicker

document.querySelectorAll('.cf7-fileupload input[type="file"]').forEach(input => {
  input.addEventListener('focus', () => {
    input.closest('.cf7-fileupload')?.classList.add('focused');
  });
  input.addEventListener('blur', () => {
    input.closest('.cf7-fileupload')?.classList.remove('focused');
  });
});

function isLimitedCf7Upload(input) {
  return input.matches('input[type="file"].cf-7-upload');
}

function getCf7UploadRoot(input) {
  return input.closest('.cf7-fileupload-multiline')
    || input.closest('.cf7-fileupload')
    || input.closest('.wpcf7-form-control-wrap')
    || input.parentElement;
}

function getCf7UploadWrap(input) {
  return input.closest('.wpcf7-form-control-wrap');
}

function updateCf7UploadFiles(input, files) {
  if (typeof DataTransfer === 'undefined') {
    return false;
  }

  const dataTransfer = new DataTransfer();

  files.forEach(file => dataTransfer.items.add(file));
  input.files = dataTransfer.files;

  return true;
}

function removeCf7UploadFile(input, fileIndex) {
  const files = Array.from(input.files || []);

  if (!Number.isInteger(fileIndex) || fileIndex < 0 || fileIndex >= files.length) return;

  files.splice(fileIndex, 1);

  if (!updateCf7UploadFiles(input, files)) {
    getCf7UploadWrap(input)?.remove();
    return;
  }

  if (files.length === 0) {
    getCf7UploadWrap(input)?.remove();
    return;
  }

  renderCf7MultilineFileNames(input);
}

function renderCf7MultilineFileNames(input) {
  const wrap = getCf7UploadWrap(input);
  const nameContainer = wrap?.querySelector('.mfcf7-zl-multifile-name');
  const pluginDeleteButton = wrap?.querySelector('.mfcf7_zl_delete_file');

  if (!nameContainer || !input.files?.length) return;

  nameContainer.textContent = '';
  nameContainer.classList.add('cf7-upload-file-list');
  pluginDeleteButton?.classList.add('cf7-upload-bulk-delete-hidden');

  Array.from(input.files).forEach((file, index) => {
    const row = document.createElement('span');
    const fileName = document.createElement('span');
    const deleteButton = document.createElement('button');

    row.className = 'cf7-upload-file-row';
    fileName.className = 'cf7-upload-file-name';
    fileName.textContent = `${file.name} (${formatCf7UploadSize(file.size)})`;
    deleteButton.type = 'button';
    deleteButton.className = 'cf7-upload-file-delete';
    deleteButton.setAttribute('aria-label', `Remove ${file.name}`);
    deleteButton.dataset.fileIndex = index;

    row.appendChild(fileName);
    row.appendChild(deleteButton);
    nameContainer.appendChild(row);
  });
}

function parseCf7UploadLimit(value) {
  if (!value) return 0;

  const match = String(value).trim().toLowerCase().match(/^([0-9]+(?:\.[0-9]+)?)\s*([kmgt]?b?)?$/);
  if (!match) return 0;

  const units = {
    b: 1,
    k: 1024,
    kb: 1024,
    m: 1024 ** 2,
    mb: 1024 ** 2,
    g: 1024 ** 3,
    gb: 1024 ** 3,
    t: 1024 ** 4,
    tb: 1024 ** 4
  };

  return Math.round(parseFloat(match[1]) * (units[match[2] || 'b'] || 1));
}

function getCf7UploadLimit(root) {
  const input = root.querySelector('input[type="file"].cf-7-upload');
  if (!input) return null;

  const limitBytes = parseInt(input.dataset.limitBytes, 10)
    || parseCf7UploadLimit(input.dataset.limit)
    || parseCf7UploadLimit(input.getAttribute('data-limit'))
    || parseCf7UploadLimit(input.getAttribute('limit'));

  if (!limitBytes) return null;

  return {
    bytes: limitBytes,
    label: formatCf7UploadSize(limitBytes)
  };
}

function getCf7UploadTranslations() {
  return window.lumicapitalForms?.upload || {
    notice: 'Failide kogumahu piirang: %s.',
    error: 'Failide kogumaht ületab lubatud piirangu %s.',
    units: ['B', 'KB', 'MB', 'GB']
  };
}

function formatCf7UploadSize(bytes) {
  const units = getCf7UploadTranslations().units || ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }

  const formattedSize = Number.isInteger(size) ? size : size.toFixed(1);

  return `${formattedSize} ${units[unitIndex]}`;
}

function getCf7UploadMessage(type, limitLabel) {
  const message = getCf7UploadTranslations()[type] || '';

  return message.replace('%s', limitLabel);
}

function ensureCf7UploadLimitNotice(root) {
  const limit = getCf7UploadLimit(root);
  if (!limit) return null;

  let notice = root.querySelector('.cf7-upload-limit-notice');

  if (!notice) {
    notice = document.createElement('span');
    notice.className = 'cf7-upload-limit-notice';
    root.appendChild(notice);
  }

  notice.textContent = getCf7UploadMessage('notice', limit.label);

  return notice;
}

function ensureCf7UploadError(root) {
  let error = root.querySelector('.cf7-upload-size-error');

  if (!error) {
    error = document.createElement('span');
    error.className = 'wpcf7-not-valid-tip cf7-upload-size-error';
    error.setAttribute('aria-hidden', 'true');
    root.appendChild(error);
  }

  return error;
}

function getCf7UploadTotalSize(root) {
  let totalSize = 0;

  root.querySelectorAll('input[type="file"].cf-7-upload').forEach(input => {
    Array.from(input.files || []).forEach(file => {
      totalSize += file.size;
    });
  });

  return totalSize;
}

function setCf7UploadValidity(root) {
  const inputs = Array.from(root.querySelectorAll('input[type="file"].cf-7-upload'));
  const limit = getCf7UploadLimit(root);
  const error = ensureCf7UploadError(root);
  const totalSize = getCf7UploadTotalSize(root);
  const isOverLimit = limit && totalSize > limit.bytes;
  const errorMessage = isOverLimit ? getCf7UploadMessage('error', limit.label) : '';

  inputs.forEach(input => {
    input.classList.toggle('wpcf7-not-valid', isOverLimit);
    input.setAttribute('aria-invalid', isOverLimit ? 'true' : 'false');
    input.setCustomValidity(errorMessage);
  });

  root.classList.toggle('cf7-upload-has-error', isOverLimit);
  error.textContent = errorMessage;
  error.setAttribute('aria-hidden', isOverLimit ? 'false' : 'true');

  return !isOverLimit;
}

function setupCf7UploadLimitNotices(scope = document) {
  scope.querySelectorAll('input[type="file"].cf-7-upload').forEach(input => {
    const root = getCf7UploadRoot(input);

    if (!root) return;

    ensureCf7UploadLimitNotice(root);
    setCf7UploadValidity(root);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  setupCf7UploadLimitNotices();
});

document.addEventListener('change', event => {
  const input = event.target;

  if (!(input instanceof HTMLInputElement) || !isLimitedCf7Upload(input)) return;

  const root = getCf7UploadRoot(input);
  if (!root) return;

  setTimeout(() => {
    renderCf7MultilineFileNames(input);
  }, 0);
  ensureCf7UploadLimitNotice(root);
  setCf7UploadValidity(root);
});

document.addEventListener('click', event => {
  if (!(event.target instanceof Element)) return;

  const fileDeleteButton = event.target.closest('.cf7-upload-file-delete');

  if (fileDeleteButton) {
    const wrap = fileDeleteButton.closest('.wpcf7-form-control-wrap');
    const input = wrap?.querySelector('input[type="file"].cf-7-upload');
    const root = input ? getCf7UploadRoot(input) : null;

    if (!input || !root) return;

    removeCf7UploadFile(input, parseInt(fileDeleteButton.dataset.fileIndex, 10));
    setCf7UploadValidity(root);
    return;
  }

  const deleteButton = event.target.closest('.mfcf7_zl_delete_file');
  if (!deleteButton) return;

  const root = deleteButton.closest('.cf7-fileupload-multiline');
  if (!root) return;

  setTimeout(() => {
    setCf7UploadValidity(root);
  }, 0);
});

document.addEventListener('submit', event => {
  const form = event.target;

  if (!(form instanceof HTMLFormElement) || !form.closest('.wpcf7')) return;

  let isValid = true;
  let firstInvalidRoot = null;

  form.querySelectorAll('input[type="file"].cf-7-upload').forEach(input => {
    const root = getCf7UploadRoot(input);
    if (!root) return;

    if (!setCf7UploadValidity(root)) {
      isValid = false;
      firstInvalidRoot = firstInvalidRoot || root;
    }
  });

  if (!isValid) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const focusTarget = firstInvalidRoot.querySelector('input[type="button"], input[type="file"]');
    focusTarget?.focus();
  }
}, true);

document.addEventListener('DOMContentLoaded', function () {
  const htmlLang = document.documentElement.lang;
  const datepickerData = document.getElementById('datepicker-data');

  const customDays = JSON.parse(datepickerData.getAttribute('data-days'));
  const customMonths = JSON.parse(datepickerData.getAttribute('data-months'));
  const customOverlayMonths = JSON.parse(datepickerData.getAttribute('data-overlay-months'));
  const placeholder = JSON.parse(datepickerData.getAttribute('data-placeholder'));
  const overlayPlaceholder = JSON.parse(datepickerData.getAttribute('data-overlay-placeholder'));

  let activePicker = null; // keep track of the currently open picker

  document.querySelectorAll('input[type="text"].cf7-date').forEach(input => {
    input.setAttribute('placeholder', placeholder.toLowerCase());
    input.setAttribute('autocomplete', 'off');
    // input.setAttribute('readonly', true); // prevent keyboard popup

    let pickerInstance = null; // store picker reference

    input.addEventListener('click', () => {
      // Close any other open picker first
      if (activePicker && activePicker !== pickerInstance) {
        activePicker.hide();
      }

      // Only initialize if not already done
      if (!pickerInstance) {
        pickerInstance = datepicker(input, {
          startDate: new Date(),
          customDays,
          customMonths,
          customOverlayMonths,
          minDate: new Date(),
          position: 'bl',
          startDay: 1,
          disableYearOverlay: 1,
          overlayPlaceholder,
          formatter: (input, date) => {
            const options = { year: "numeric", month: "2-digit", day: "2-digit" };
            input.value = date.toLocaleDateString(htmlLang, options);
          },
          onShow: (instance) => {
            activePicker = instance; // track the active picker
          },
          onHide: (instance) => {
            if (activePicker === instance) activePicker = null;
          },
          onSelect: (instance, date) => {
            // Blur input first, then hide
            instance.el.blur();
            setTimeout(() => {
              instance.hide();
            }, 20); // small delay prevents immediate reopen
          }
        });
      }

      pickerInstance.show(); // show immediately after initialization
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const row = document.querySelector('.more-people-row') ? document.querySelector('.more-people-row') : null;
  if (!row) return;
  const hiddenField = row.querySelector('input[name="persons"]') ? row.querySelector('input[name="persons"]') : null;
  const addBtn = row.querySelector('.add-person-btn') ? row.querySelector('.add-person-btn') : null;
  const removeBtn = row.querySelector('.remove-person-btn') ? row.querySelector('.remove-person-btn') : null;
  const radios = document.querySelectorAll('input[name="adult_count"]') ? Array.from(document.querySelectorAll('input[name="adult_count"]')) : [];


  // Update buttons visibility based on current value
  function updateButtons(value) {
    removeBtn.style.display = value <= 1 ? 'none' : 'inline-flex';
    addBtn.style.display = value >= 4 ? 'none' : 'inline-flex';
  }

  // Update radio buttons based on value
  function updateRadios(value) {
    radios.forEach(radio => {
      radio.checked = parseInt(radio.value, 10) === value;
    });
  }

  // Update hidden field and UI
  function updateValue(value) {
    value = Math.max(1, Math.min(4, value)); // clamp between 1 and 4
    hiddenField.value = value;
    updateButtons(value);
    updateRadios(value);
  }

  if (!hiddenField || !addBtn || !removeBtn || radios.length === 0) {
    return; // required elements not found
  }
  // Initial sync
  updateValue(parseInt(hiddenField.value, 10));

  // Add person button
  addBtn.addEventListener('click', () => {
    let value = parseInt(hiddenField.value, 10);
    updateValue(value + 1);
  });

  // Remove person button
  removeBtn.addEventListener('click', () => {
    let value = parseInt(hiddenField.value, 10);
    updateValue(value - 1);
  });

  // Radio buttons change
  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      if (radio.checked) {
        updateValue(parseInt(radio.value, 10));
      }
    });
  });
});



document.querySelectorAll('.cf7-fileupload input[type="file"]').forEach(input => {
  const labelText = input.closest('.cf7-fileupload').querySelector('.fileupload-text');

  input.addEventListener('change', () => {
    if (input.files.length === 0) {
      labelText.textContent = "Lisa fail";
    } else if (input.files.length === 1) {
      labelText.textContent = input.files[0].name;
    } else {
      labelText.textContent = `${input.files.length} faili valitud`;
    }
  });
});

// Reusable helper: select the only radio inside a group (if exactly one)
function first_selected_function(groupSelector) {
  const group = document.querySelector(groupSelector);
  if (!group) return false;

  const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
  if (radios.length === 1) {
    const onlyRadio = radios[0];
    if (!onlyRadio.checked) {
      onlyRadio.checked = true;
      onlyRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }
  return false;
}

// For CF7 conditional reveal timing, run after the DOM updates
function selectSingleRadioAfterReveal(groupSelector) {
  // two RAFs to wait a frame or two for CF7 to toggle visibility/DOM
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      first_selected_function(groupSelector);
    });
  });
}
if (!document.body.classList.contains('page-template-uurimise-avaldus-php')) {
  document.addEventListener('DOMContentLoaded', function () {
    // Map service checkbox names -> their corresponding group containers
    const serviceToGroup = {
      'selected-services-yard-parking[]': '[data-orig_data_id="group-yard-parking"]',
      'selected-services-building-parking[]': '[data-orig_data_id="group-building-parking"]',
      'selected-services-electric-parking[]': '[data-orig_data_id="group-electric-parking"]',
      'selected-services-motorbike-parking[]': '[data-orig_data_id="group-motorbike-parking"]',
      'selected-services-storage-space[]': '[data-orig_data_id="group-storage-space"]',
      'selected-services-bike-storage[]': '[data-orig_data_id="group-bike-storage"]',
    };

    // Attach listeners to each service checkbox group
    Object.entries(serviceToGroup).forEach(([checkboxName, groupSelector]) => {
      const boxes = document.querySelectorAll(`input[name="${checkboxName}"]`);
      boxes.forEach((box) => {
        box.addEventListener('change', () => {
          // Only act when a service becomes selected
          if (box.checked) {
            selectSingleRadioAfterReveal(groupSelector);
          }
        });
      });

      // Handle pre-checked state (e.g., browser restore / server-side defaults)
      if ([...boxes].some(b => b.checked)) {
        selectSingleRadioAfterReveal(groupSelector);
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const proxySubmit = document.getElementById('proxy-submit');
  const form = document.querySelector('.cf7-contract .wpcf7 form');
  const proxyOutput = document.getElementById('proxy-wpcf7-response-output');

  if (!proxySubmit || !form || !proxyOutput) return;

  form.classList.add('has-proxy');

  const realSubmit = form.querySelector('.wpcf7-submit');
  const realOutput = form.querySelector('.wpcf7-response-output');

  const cf7StateClasses = [
    'init',
    'submitting',
    'sent',
    'failed',
    'aborted',
    'spam',
    'invalid',
    'unaccepted',
    'payment-required',
    'resetting'
  ];

  proxySubmit.addEventListener('click', function (event) {
    event.preventDefault();

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  });

  function mirrorFormStateToProxy() {
    proxyOutput.classList.remove(...cf7StateClasses);

    cf7StateClasses.forEach(function (className) {
      if (form.classList.contains(className)) {
        proxyOutput.classList.add(className);
      }
    });

    const status = form.getAttribute('data-status');

    if (status && cf7StateClasses.includes(status)) {
      proxyOutput.classList.add(status);
    }
  }

  function syncCf7Response() {
    if (!realOutput) return;

    const message = realOutput.textContent.trim();

    mirrorFormStateToProxy();

    if (!message) {
      proxyOutput.textContent = '';
      proxyOutput.setAttribute('aria-hidden', 'true');
      return;
    }

    proxyOutput.textContent = message;
    proxyOutput.setAttribute('aria-hidden', 'false');
  }

  [
    'wpcf7invalid',
    'wpcf7spam',
    'wpcf7mailsent',
    'wpcf7mailfailed',
    'wpcf7submit',
    'wpcf7reset'
  ].forEach(function (eventName) {
    form.addEventListener(eventName, function () {
      setTimeout(syncCf7Response, 50);
    });
  });

  const observer = new MutationObserver(syncCf7Response);

  observer.observe(form, {
    attributes: true,
    attributeFilter: ['class', 'data-status']
  });

  if (realOutput) {
    observer.observe(realOutput, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  syncCf7Response();
});
